<script setup lang="ts">
import type { SidebarItem } from '~/data/studentNavs'

defineProps({
  title: { type: String, required: true },
  links: { type: Array as PropType<SidebarItem[]>, required: true }
})

// Routing
const route = useRoute()
const path = route.path
</script>

<template>
  <div class="layout-sidebar">
    <span class="layout-sidebar-title">{{ title }}</span>

    <div class="layout-sidebar-list">
      <LayoutSidebarItem v-for="link in links" :key="`${link.title}`" :item="link" :path="path" />
    </div>

    <div class="layout-sidebar-content">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
.layout-sidebar {
  padding: 25px 15px;
  /* padding-right: 0; */
  position: fixed;
  width: var(--sidebarWidth);
  top: var(--navbarHeight);
  height: calc(100dvh - var(--navbarHeight));
  overflow-y: scroll;
  border-right: 1px solid var(--borderL2);

  &-title {
    font-size: 0.83rem;
    font-weight: 500;
    color: var(--textM2);
    text-transform: uppercase;
  }

  &-list {
    margin-top: 15px;
    display: grid;
    gap: 5px;
  }

  &-content {
    margin: 30px 0 0;
  }
}
</style>
